// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BhYh","content":"styles_content__wKTsC","row":"styles_row__dQdZ-","footer":"styles_footer__3ABqA","phraseLength":"styles_phraseLength__25HUV"};